import { gsapScramble } from "../utils/scrambleText";

export default function initScrambleText() {
  const scrambleText = document.querySelectorAll("[data-scramble-text] span");
  if (!scrambleText.length) return;

  scrambleText.forEach((scramble) => {
    const duration = scramble.dataset.scrambleDuration ? +scramble.dataset.scrambleDuration : undefined;
    const delay = scramble.dataset.scrambleDelay ? +scramble.dataset.scrambleDelay : undefined;

    gsapScramble(scramble, duration, delay);
  });
}
